import http from "../http-common";
import authHeader from './auth-header';

const API_URL = 'blowers';

class BlowerService {
    get(id) {
        return http.get(API_URL + `/${id}`, { headers: authHeader() });
    }

    getAllPending() {
        return http.get(API_URL, { params: { pending: 1 }, headers: authHeader() });
    }

    create(data) {
        return http.post(API_URL, data, { headers: authHeader() });
    }

    update(id, data) {
        return http.patch(API_URL + `/${id}`, data, { headers: authHeader() });
    }

    delete(id) {
        return http.delete(API_URL + `/${id}`, { headers: authHeader() });
    }
}

export default new BlowerService();